import React, { useEffect, useState } from 'react';
import DataGridComponent from 'Utils/Helpers/DataGridComponent';
import { patientListMain } from 'Utils/Helpers/TableColumns';
import { useSelector, useDispatch } from 'react-redux';
import NewPatientMain from './components/New';
import * as icons from 'react-bootstrap-icons';
import Pagination from '@mui/material/Pagination';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import CButton from 'Utils/Helpers/CButton';
import { getPatients } from 'http/components/PatientService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetPatientData } from 'Utils/Helpers/HandleApiData';
import { enqueueSnackbar } from 'notistack';

export default function PatientsIndex() {
    const dispatch = useDispatch();
    const [data, setData] = useState();
    const [pagin, setPagin] = useState();
    const [column, setColumn] = useState([]);
    const [newPatient, setNewPatient] = useState(false);
    const [searchValue, setSearchValue] = useState({ data: '', page: 1, limit: 15 });
    const { patient, pagination, current } = useSelector((state) => ({
        patient: state.patient.patients,
        pagination: state.patient.pagination,
        current: state.staff.current,
    }));
    const [controls, setControls] = useSetState ({
        search: {
          id: "search",
          type: 'text',
          placeholder: 'جستجو کنید...',
          value: '',
          icon: <icons.ListTask/>,
        },
    });

    const setControlsValue = (name, value) => {
        setControls({ [name]: { value: value } });
    }

    useEffect(() => {
        getData(searchValue)
    }, [searchValue])

    useEffect(() => {
        if(current && current.length !== 0 && current[2][0]) {
            if(patient) {
                setData(patient);
                setPagin(pagination);
            }
            setNewPatient(current[2][4]);
            if(!current[2][1] && !current[2][2] && !current[2][3]) {
                let _new = patientListMain;
                _new.splice(4,1);
                setColumn(_new)
            } else {
                let _new = patientListMain;
                let w = 0;
                if(current[2][1]) w+=40;
                if(current[2][2]) w+=40;
                if(current[2][3]) w+=40;
                _new[4].width = w;
                setColumn(_new)
            }
        }
    }, [patient, current])

    const onPageChange = async (event, newPage) => {
        if(pagination.page !== newPage) {
            setSearchValue({ ...searchValue, page: newPage })
        } else {
            enqueueSnackbar('هم اکنون در همین صفحه هستید', {variant: 'info'});
        }
    }

    const onSearch = async () => {
        dispatch(HandleLoading(true));
        setTimeout(() => {
            setSearchValue({ ...searchValue, data: controls.search.value, page: 1 })
        }, 500);
    }

    const getData = async (data) => {
        const response = await getPatients(data);
        dispatch(HandleLoading(true));
        if(response.status) {
            dispatch(SetPatientData(response.data));
        } else {
            dispatch(HandleLoading(false));
        }
    }

    return (
        <div className='content'>
            <div className='search-patient'>
                {
                    Object.keys(controls).map((key, index) => {
                    return (
                        <Inputer
                            key={`inputer_${controls[key].id}`}
                            id={controls[key].id}
                            type={controls[key].type}
                            placeholder={controls[key].placeholder}
                            value={controls[key].value}
                            setValue={setControlsValue.bind(this)}
                            icon={controls[key].icon}
                            onKeyEnterActive={true}
                            onKeyEnter={onSearch}
                            className={'text-search-box'}
                        />
                    )
                    })
                }
                <CButton
                    icon={<icons.Search/>}
                    onClick={onSearch}
                    className={'btn-search'}
                />
            </div>
            {
                (data && data.length !== 0 && column.length !==0)
                ? <>
                    <div className='text-center'>
                        {
                            (pagin && pagin.totalPages !== 1) &&
                            <div className='p-1 mb-1 felx-row-center-center border rounded-3 ' dir='ltr'>
                                <Pagination
                                    count={pagin.totalPages}
                                    page={pagin.page}
                                    shape="rounded"
                                    size="small"
                                    onChange={onPageChange}
                                    hidePrevButton
                                    hideNextButton
                                />
                            </div>
                        }
                        <div className="w-100">
                            <DataGridComponent
                                data={data}
                                columns={column}
                                className={`${(pagin && pagin.totalPages !== 1) ? 'h-with-search2' : 'h-with-search'}`}
                            />
                        </div>
                    </div>
                </> : <div className='w-100 text-center pt-4'>
                    <small>{"اطلاعاتی برای نمایش وجود ندارد"}</small>
                </div>
            }
            {newPatient && <NewPatientMain />}
        </div>
    );
}